import { styled } from '@linaria/react';
import React, { useEffect, useState } from 'react';
import { Checkbox } from '../Checkbox';

const CheckListColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;


const CheckListContainer = styled.div<{ column: number }>`
  display: grid;
  grid-template-columns: ${(props) => '1fr '.repeat(props.column)};
  gap: 24px;
  @media screen and (max-width: 767.98px) {
    grid-template-columns: 1fr;
  }
`;


export interface CheckListItem {
  text: string;
  value: string;
}

export interface CheckboxListingProps {
  checkList: CheckListItem[];
  values?: string[];
  column: number;
  rowPerColumn: number;
  onCheckedChange: (checkedList: string[]) => void;
}

export const CheckboxListing = ({
  checkList,
  values,
  column,
  rowPerColumn,
  onCheckedChange,
  ...props
}: CheckboxListingProps) => {
  const actualColumn = Math.ceil(checkList.length / rowPerColumn);
  const [checkedList, setCheckedList] = useState<string[]>(values ? values : []);

  useEffect(() => {
    onCheckedChange(checkedList);
  }, [checkedList, onCheckedChange]);
  
  const onItemCheck = (e: any) => {
    if (e.target.value) {
      setCheckedList([...checkedList, e.target.name]);
    } else {
      setCheckedList(checkedList.filter((item) => item !== e.target.name));
    }
  };

  return (
    <CheckListContainer column={column}>
      {Array(actualColumn)
        .fill(0)
        .map((v, index) => (
          <CheckListColumn key={index}>
            {[...checkList]
              .splice(index * rowPerColumn, rowPerColumn)
              .map((checkListItem) => (
                <Checkbox onChange={onItemCheck} name={checkListItem.value} checked={checkedList.includes(checkListItem.value)} >
                  {checkListItem.text}
                </Checkbox>
              ))}
          </CheckListColumn>
        ))}
    </CheckListContainer>
  );
};
